module.exports = __webpack_public_path__ + "b1dfda6761a18916443b83e2192550a6.webm";